import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, unref as _unref, withModifiers as _withModifiers, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "divide-y space-y-4"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", { class: "modal__header" }, [
  /*#__PURE__*/_createElementVNode("h2", null, "Get started"),
  /*#__PURE__*/_createElementVNode("p", { class: "modal__description" }, "Log in to donate and buy/sell NFT")
], -1)
const _hoisted_3 = /*#__PURE__*/_createTextVNode(" Login with wallet ")
const _hoisted_4 = /*#__PURE__*/_createTextVNode(" Login ")
const _hoisted_5 = /*#__PURE__*/_createTextVNode(" Not registered yet? ")
const _hoisted_6 = { key: 1 }
const _hoisted_7 = /*#__PURE__*/_createElementVNode("div", { class: "modal__header" }, [
  /*#__PURE__*/_createElementVNode("h2", null, "Create an account")
], -1)
const _hoisted_8 = /*#__PURE__*/_createTextVNode(" Create account ")
const _hoisted_9 = /*#__PURE__*/_createTextVNode(" Already a member? ")

import useToastMessage from '@/composables/useToastMessage';
import { useUserStore } from '@/store/user';
import { ref, reactive, computed } from 'vue';


export default /*#__PURE__*/_defineComponent({
  emits: ['update:modelValue'],
  setup(__props, { emit: emits }) {


const userStore = useUserStore();
const { error } = useToastMessage();

const isLogin = ref(true);
const toggleSignup = () => {
  isLogin.value = !isLogin.value;
};

const login = reactive({
  username: '',
  password: '',
});
const submitLogin = async (isWallet?: boolean) => {
  try {
    if (isWallet) await userStore.connectWallet();
    else await userStore.login(login.username, login.password);
    emits('update:modelValue', false);
  } catch (err) {
    error(err);
  }
};

const newAccount = reactive({
  email: '',
  password: '',
});
const confirmPassword = ref('');
const isSignupInvalid = computed(() => {
  const unmatchedPassword = newAccount.password !== confirmPassword.value;
  return newAccount.password === '' || unmatchedPassword;
});
const createAccount = async () => {
  try {
    await userStore.signup(newAccount.email, newAccount.password);
    emits('update:modelValue', false);
  } catch (err) {
    error(err);
  }
};

return (_ctx: any,_cache: any) => {
  const _component_BaseButton = _resolveComponent("BaseButton")!
  const _component_BaseInputText = _resolveComponent("BaseInputText")!
  const _component_BaseModal = _resolveComponent("BaseModal")!

  return (_openBlock(), _createBlock(_component_BaseModal, {
    "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => (emits('update:modelValue', $event))),
    onClosed: _cache[10] || (_cache[10] = ($event: any) => (isLogin.value = true))
  }, {
    default: _withCtx(() => [
      (isLogin.value)
        ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
            _createElementVNode("div", null, [
              _hoisted_2,
              _createVNode(_component_BaseButton, {
                "color-scheme": "primary",
                full: "",
                onClick: _cache[0] || (_cache[0] = ($event: any) => (submitLogin(true))),
                "data-testid": "modal-auth-login-metamask"
              }, {
                default: _withCtx(() => [
                  _hoisted_3
                ]),
                _: 1
              })
            ]),
            _createElementVNode("form", {
              class: "space-y-4 py-4",
              onSubmit: _cache[4] || (_cache[4] = _withModifiers(() => {}, ["prevent"]))
            }, [
              _createVNode(_component_BaseInputText, {
                modelValue: _unref(login).username,
                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_unref(login).username) = $event)),
                placeholder: "Email",
                "data-testid": "modal-auth-email"
              }, null, 8, ["modelValue"]),
              _createVNode(_component_BaseInputText, {
                modelValue: _unref(login).password,
                "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_unref(login).password) = $event)),
                type: "password",
                placeholder: "Password",
                "data-testid": "modal-auth-password"
              }, null, 8, ["modelValue"]),
              _createVNode(_component_BaseButton, {
                type: "submit",
                "color-scheme": "primary",
                full: "",
                onClick: _cache[3] || (_cache[3] = ($event: any) => (submitLogin())),
                "data-testid": "modal-auth-submit"
              }, {
                default: _withCtx(() => [
                  _hoisted_4
                ]),
                _: 1
              }),
              _createElementVNode("p", { class: "text-center" }, [
                _hoisted_5,
                _createElementVNode("a", {
                  role: "button",
                  class: "text-primary",
                  onClick: toggleSignup
                }, " Create an account ")
              ])
            ], 32)
          ]))
        : (_openBlock(), _createElementBlock("div", _hoisted_6, [
            _hoisted_7,
            _createElementVNode("form", {
              onSubmit: _cache[8] || (_cache[8] = _withModifiers(() => {}, ["prevent"])),
              class: "space-y-4"
            }, [
              _createVNode(_component_BaseInputText, {
                modelValue: _unref(newAccount).email,
                "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_unref(newAccount).email) = $event)),
                placeholder: "Email",
                "data-testid": "modal-auth-create-email"
              }, null, 8, ["modelValue"]),
              _createVNode(_component_BaseInputText, {
                modelValue: _unref(newAccount).password,
                "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_unref(newAccount).password) = $event)),
                type: "password",
                placeholder: "Password",
                "data-testid": "modal-auth-create-password"
              }, null, 8, ["modelValue"]),
              _createVNode(_component_BaseInputText, {
                modelValue: confirmPassword.value,
                "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((confirmPassword).value = $event)),
                type: "password",
                placeholder: "Confirm Password",
                "data-testid": "modal-auth-create-confirm-password"
              }, null, 8, ["modelValue"]),
              _createVNode(_component_BaseButton, {
                type: "submit",
                full: "",
                "color-scheme": "primary",
                disabled: _unref(isSignupInvalid),
                onClick: createAccount,
                "data-testid": "modal-auth-create-submit"
              }, {
                default: _withCtx(() => [
                  _hoisted_8
                ]),
                _: 1
              }, 8, ["disabled"]),
              _createElementVNode("p", { class: "text-center" }, [
                _hoisted_9,
                _createElementVNode("a", {
                  role: "button",
                  class: "text-primary",
                  onClick: toggleSignup
                }, " Sign in ")
              ])
            ], 32)
          ]))
    ]),
    _: 1
  }))
}
}

})